module.exports = __webpack_public_path__ + "img/img3.ace469c9.jpg";